import { Moon, Sun1 } from 'iconsax-react'

import useTheme from '@/hooks/useSwitchTheme'
import { cn } from '@/lib/utils'
import { weCheckPalette } from '@/utils/palette/weCheckPalette'

const SLOT_BASE =
  'flex h-6 w-6 items-center justify-center rounded-full transition-colors'

export const DarkModeSwitch = () => {
  const { isDarkMode, toggleTheme } = useTheme()

  return (
    <button
      type="button"
      role="switch"
      aria-checked={isDarkMode}
      aria-label="Toggle dark mode"
      onClick={toggleTheme}
      className="inline-flex items-center gap-1 rounded-full border border-neutralColor5 p-1"
    >
      <span
        className={cn(SLOT_BASE, !isDarkMode && 'bg-primaryColor')}
      >
        <Sun1
          size={14}
          color={
            !isDarkMode ? weCheckPalette.staticWhite : weCheckPalette.neutralColor60
          }
          variant="Bold"
        />
      </span>
      <span
        className={cn(SLOT_BASE, isDarkMode && 'bg-primaryColor')}
      >
        <Moon
          size={14}
          color={
            isDarkMode ? weCheckPalette.staticWhite : weCheckPalette.neutralColor60
          }
          variant="Bold"
        />
      </span>
    </button>
  )
}
